import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router/es';

export default class RecipeSearchItems extends Component {
  static propTypes = {
    tabName: PropTypes.string,
    title: PropTypes.string,
    id: PropTypes.number,
    onItemClick: PropTypes.func,
    skey: PropTypes.string,
  };
  constructor() {
    super();
  }

  onClick = () => {
    const { id, tabName, title, onItemClick } = this.props;
    onItemClick(id, title, tabName);
  }
  
  render() {
    const { title, tabName, skey } = this.props;
    const keyIndex = title.toLowerCase().indexOf(skey.toLowerCase());
    let boldPrevTitle = title.substring(0, keyIndex);
    let boldTitle = title.substring(keyIndex, keyIndex + skey.length);
    let boldNextTitle = title.substring(keyIndex + skey.length);
    if (keyIndex < 0) {
      boldPrevTitle = null;
      boldTitle = null;
      boldNextTitle = title;
    }

    return (
      <div className='pointer search-item' onClick = { this.onClick }>
        <Link>{boldPrevTitle}<b>{boldTitle}</b>{boldNextTitle}</Link>
        <div>{ tabName }</div>
      </div>
    );
  }
}
